<section>
  <div class="card" [ngClass]="{'type-b': templateSuffix !== ''}">
    <div class="img-container">
      <img [src]="summary.carImage" alt="" />
    </div>

    <app-resume-quoter
      [showTitle]="true"
      [brand]="summary.carTitle"
      [version]="summary.carModel"
      [priceWithIva]="summary.priceWithIva"
      [stateName]="summary.state"
      [ri]="summary.refund"
      [concept]="summary.concept === 'afin' || summary.concept === 'rr' ? 'Rent2Buy' : isCredit(summary.concept) ? summary.concept === typeProduct.Traditional ? summary.deadlineSelect.annuity ? 'Crédito tradicional anualidades' : 'Crédito tradicional' : 'Crédito Ballon' : summary.concept"
      [period]="summary.period"
      [initialPayment]="summary.initialPayment"
      [monthlyPayment]="summary.monthlyPayment"
      [insurance]="summary.insurance"
      [isRecalculated]="isRecalculated"
      [purchaseValue]="summary.purchaseValue"
      [isCredit]="isCredit(summary.concept)"
      [isBallon]="isCredit(summary.concept) && summary.concept !== typeProduct.Traditional" 
      [hitch]="summary.deadlineSelect.downPayment" 
      [annuity]="summary.deadlineSelect.annuity"
      [rate]="summary.deadlineSelect?.finalRate?.finalRate" 
      [ballon]="summary.dataQuoter?.ballon"
      [cat]="summary.deadlineSelect?.cat"
    ></app-resume-quoter>

    <div class="container-btn-file" *ngIf="templateSuffix === ''">
      <app-pdf
        *ngIf="summary.deadlineSelect && !isCredit(summary.concept)"
        [dataQuoter]="summary.dataQuoter"
        [car]="summary.car"
        [deadlineSelect]="summary.deadlineSelect"
        [stateSelected]="summary.stateSelected"
        [insuranceSelected]="summary.insuranceSelected"
        [allDeadlineSelect]="summary.extraPeriods"
      ></app-pdf>

      <app-pdf-credit *ngIf="summary.deadlineSelect && isCredit(summary.concept)"
        [dataQuoter]="summary.dataQuoter"
        [car]="summary.car"
        [deadlineSelect]="summary.deadlineSelect"
        [stateSelected]="summary.stateSelected"
        [insuranceSelected]="summary.insuranceSelected"
        ></app-pdf-credit>
    </div>

    <!-- FORD: Campaign -->
    <div class="container-btn-file" *ngIf="templateSuffix !== ''">
      <app-pdf-ford
        *ngIf="summary.deadlineSelect && !isCredit(summary.concept)"
        [dataQuoter]="summary.dataQuoter"
        [car]="summary.car"
        [deadlineSelect]="summary.deadlineSelect"
        [stateSelected]="summary.stateSelected"
        [registrationState]="summary.registrationState"
        [insuranceSelected]="summary.insuranceSelected"
        [allDeadlineSelect]="summary.extraPeriods"
        [ruleFifteen]="ruleFifteen"
      ></app-pdf-ford>

    </div>

    <button *ngIf="!destroyBtn" id="boton-quiero-cambiar-unidad{{templateSuffix !== '' ? '-b' : '' }}" mat-button
      class="btn-danger-custom" [disabled]="isBlocked || isErrorBuro" (click)="changeCar()">
      Quiero cambiar la unidad
    </button>
  </div>
</section>